import request from "./request";

// 根据立牌支付编码返回商户信息
export function getbrandbyqrcode(params) {
  return request({
    url: '/webapi/WxMall/getbrandbyqrcode',
    method: 'get',
    params
  })
}

// 扫码支付会员登录后根据商户Id获取支付及会员信息
export function wxscanmember(params) {
  return request({
    url: '/webapi/WxMall/wxscanmember',
    method: 'get',
    params,
  })
}

// 微信扫码支付
export function wxscanpay(data) {
  return request({
    url: '/webapi/WxMall/wxscanpay',
    method: 'post',
    data,
  })
}

// 取消订单
export function cancelorder(params) {
  return request({
    url: '/webapi/WxMall/cancelorder',
    method: 'get',
    params
  })
}

// 根据银联标识获取会员信息
export function getmemberbyKey (params, loading = false) {
  return request({
    url: '/webapi/WxMp/getmember',
    params,
    method: 'get',
    loading
  })
}

// 绑定会员发送验证码
export function getvcode (params) {
  return request({
    url: '/webapi/wxmp/getvcode',
    params,
    method: 'get'
  })
}

// 注册
export function wxmallmemberregister (params) {
  return request({
    url: '/webapi/WxMall/wxmallmemberregister',
    params,
    method: 'post'
  })
}

// 发起支付
export function submitPay(data) {
  return request({
    url: `/api/pay/submit`,
    data,
    method: 'post'
  })
}

//收银台初始信息
export function cashierInfo(params) {
  return request({
    url: `/api/pay/info`,
    params,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/lib/js/api.js